/**
 * MO Cart Handler - Bundle removal for cart line items
 * Migrated from src/alpine/store/custom-cart-handler.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  window.MO.cartHandler = {
    init: function () {
      var self = this;
      setTimeout(function () {
        self.initCartLineItemTriggers();
      }, 400);

      window.addEventListener("SCE:mutate", function () {
        setTimeout(function () {
          self.initCartLineItemTriggers();
        }, 400);
      });
    },

    getCart: async function () {
      var res = await fetch(window.Shopify.routes.root + "cart.js");
      return res.json();
    },

    initCartLineItemTriggers: function () {
      var allRemoveButtons = document.querySelectorAll("[ev-remove-btn]");
      if (allRemoveButtons.length === 0) return;

      allRemoveButtons.forEach(function (btn) {
        // Prevent double-binding
        if (btn._moCartBound) return;
        btn._moCartBound = true;

        btn.addEventListener("click", async function () {
          var bundleHash = btn.dataset.bundleHash;
          var updates = {};
          document
            .querySelectorAll('[data-bundle-hash="' + bundleHash + '"]')
            .forEach(function (el) {
              updates[el.dataset.key] = 0;
            });

          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          });

          window.location.reload();
        });
      });
    }
  };
})();
